export default "__VITE_ASSET__Jl2P1leL__"